import React, { Fragment } from 'react'

// routing
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'

// import bootstrap
import '../Assets/css/bootstrap.min.css'
import '../Assets/css/responsive.css'

// redux
import { Provider } from 'react-redux'
import store from '../Store/Store'

// Rutas Privadas
//import PrivateRoute from './Utiles/PrivateRoute';

// components
import Home from './Home/Home'
import InformesHome from './Informes/InformesHome'
import InformeConciliacion from './Informes/InformeConciliacion'
import {
    INFORMES_HOME_PATH,
    INFORMES_CONCILIACION_PATH,
} from './Informes/informesHub'
import Configuracion from './Configuracion/Configuracion'
import { CONFIGURACION_PATH } from './Configuracion/configuracionAccess'

import ConsolaVenta from './ConsolaVenta/Ventas'

import AddArticulo from './Articulo/AddArticulo'
import AddArticuloCompuestos from './Articulo/AddArticuloCompuesto'
import AddArticuloImportar from './Articulo/AddArticuloImportar'
import Articulos from './Articulo/Articulos'
import ArticulosEliminados from './Articulo/ArticulosEliminados'
import EditArticulo from './Articulo/EditArticulo'
import EditArticuloCompuesto from './Articulo/EditArticuloCompuesto'

import AddDepartamento from './Departamento/AddDepartamento'
import AddDepartamentoImportar from './Departamento/AddDepartamentoImportar'
import Departamentos from './Departamento/Departamentos'
import DepartamentosEliminados from './Departamento/DepartamentosEliminados'
import EditDepartamento from './Departamento/EditDepartamento'

import AddFamilia from './Familia/AddFamilia'
import AddFamiliaImportar from './Familia/AddFamiliaImportar'; //
import EditFamilia from './Familia/EditFamilia'
import FamiliaEliminada from './Familia/FamiliaEliminada'
import Familias from './Familia/Familias'

import AddMarca from './Marca/AddMarca'
import AddMarcaImportar from './Marca/AddMarcaImportar'
import EditMarca from './Marca/EditMarca'
import Marcas from './Marca/Marcas'
import MarcasEliminadas from './Marca/MarcasEliminadas'

import AddTipoComprobante from './TipoComprobante/AddTipoComprobante'
import EditarTipoComprobante from './TipoComprobante/EditarTipoComprobante'
import TipoComprobantes from './TipoComprobante/TipoComprobantes'

import AddTarjeta from './Tarjeta/AddTarjeta'
import EditTarjeta from './Tarjeta/EditTarjeta'
import Tarjetas from './Tarjeta/Tarjetas'
import TarjetasEliminadas from './Tarjeta/TarjetasEliminadas'

import AddListaPrecio from './ListaPrecio/AddListaPrecio'
import EditListaPrecio from './ListaPrecio/EditListaPrecio'
import ImportarListaPrecio from './ListaPrecio/ImportarListaPrecio'
import ListasPrecios from './ListaPrecio/ListasPrecios'

import AddOferta from './Oferta/AddOferta'
import EditOferta from './Oferta/EditOferta'
import Ofertas from './Oferta/Ofertas'
import OfertasEliminadas from './Oferta/OfertasEliminadas'

import AddCliente from './Cliente/AddCliente'
import Clientes from './Cliente/Clientes'
import ClientesEliminados from './Cliente/ClientesEliminados'
import EditCliente from './Cliente/EditCliente'

import AddCargo from './Cargo/AddCargo'
import Cargos from './Cargo/Cargos'
import EditCargo from './Cargo/EditCargo'

import AddSucursal from './Backoffice/AddSucursal'
import EditSucursal from './Sucursal/EditSucursal'
import Sucursales from './Sucursal/Sucursales'

import AddEmpleado from './Empleado/AddEmpleado'
import EditEmpleado from './Empleado/EditEmpleado'
import Empleados from './Empleado/Empleados'
import EmpleadosEliminados from './Empleado/EmpleadosEliminados'

import AddCuentaCorriente from './CuentaCorrienteCliente/AddCuentaCorriente'
import CuentasCorrientes from './CuentaCorrienteCliente/CuentasCorrientes'
import CuentasCorrientesClienteEliminada from './CuentaCorrienteCliente/CuentasCorrientesEliminadas'
import EditCuentaCorriente from './CuentaCorrienteCliente/EditCuentaCorriente'
import CuentasCorrientesInformeVentaAdeudada from './CuentaCorrienteCliente/InformeVentaAdeudada'
import IngresoPagoCliente from './CuentaCorrienteCliente/IngresoPago'

import AddCuentaCorrienteProveedor from './CuentaCorrienteProveedor/AddCuentaCorriente'
import CuentasCorrientesProveedor from './CuentaCorrienteProveedor/CuentasCorrientes'
import CuentasCorrientesProveedorEliminada from './CuentaCorrienteProveedor/CuentasCorrientesEliminada'
import EditCuentaCorrienteProveedor from './CuentaCorrienteProveedor/EditCuentaCorriente'
import IngresoPago from './CuentaCorrienteProveedor/IngresoPago'

// import AddPedidoSucursal from './PedidoSucursal/AddPedidoSucursal';
// import PedidosSucursal from './PedidoSucursal/PedidosSucursal';

import AddStockImportar from './StockSucursal/AddStockImportar'
import AddStockSucursal from './StockSucursal/AddStockSucursal'
import EditStockSucursal from './StockSucursal/EditStockSucursal'
import StockSucursal from './StockSucursal/StockSucursal'
import InformeStockBalance from './StockSucursal/InformeStockBalance'
import StockSucursalEliminado from './StockSucursal/StockSucursalEliminado'
import GenerarEtiquetas from './StockSucursal/GenerarEtiquetas/GenerarEtiquetas'

import AddUsuario from './Usuario/AddUsuario'
import EditUsuario from './Usuario/EditUsuario'
import Usuario from './Usuario/Usuario'
import UsuariosEliminados from './Usuario/UsuariosEliminados'

import Login from './Login/Login'

import AddProveedor from './Proveedor/AddProveedor'
import EditProveedor from './Proveedor/EditProveedor'
import Proveedores from './Proveedor/Proveedores'
import ProveedoresEliminados from './Proveedor/ProveedoresEliminados'

import AddCompra from './Compra/AddCompra'
import Compras from './Compra/Compras'
import ComprasEliminadas from './Compra/ComprasEliminadas'
import InformeCompras from './Compra/InformeCompras'

import Cajas from './Caja/Cajas'
import CajasEliminadas from './Caja/CajasEliminadas'
import EditCaja from './Caja/EditCaja'
import InformeCajas from './Caja/InformeCajas'
import OpenCaja from './Caja/OpenCaja'

import Pdf from './Utiles/pdf'
import TicketVenta from './Utiles/TicketVenta'

import CorreoElectronico from './CorreoElectronico/CorreoElectronico'

import Presupuestos from './Presupuestos/Presupuestos'
import PresupuestosEliminado from './Presupuestos/PresupuestosEliminado'

import Informes from './Ventas/Informes'
import Ventas from './Ventas/Venta'
import VentaEliminada from './Ventas/VentaEliminada'

import ListasPreciosEliminados from './ListaPrecio/ListasPreciosEliminados'
import SucursalesEliminados from './Sucursal/SucursalesEliminados'

import AddPuntoVenta from './Backoffice/AddPuntoVenta'
import EditPuntoVenta from './PuntoVenta/EditPuntoVenta'
import PuntoVenta from './PuntoVenta/PuntoVenta'
import PuntoVentaEliminadas from './PuntoVenta/PuntoVentaEliminadas'

import AddDatoFiscal from './Backoffice/AddDatoFiscal'
import DatoFiscal from './DatoFiscal/DatoFiscal'
import BackofficeTenants from './Backoffice/BackofficeTenants'
import BackofficeTenantsEliminados from './Backoffice/BackofficeTenantsEliminados'
import AddTenant from './Backoffice/AddTenant'
import DatoFiscalEliminado from './DatoFiscal/DatoFiscalEliminado'
import EditDatoFiscal from './DatoFiscal/EditDatoFiscal'

import AddArticuloPrecio from './ArticuloPrecio/AddArticuloPrecio'
import ArticuloPrecio from './ArticuloPrecio/ArticuloPrecio'
import EditArticuloPrecio from './ArticuloPrecio/EditArticuloPrecio'
import ImportarArticuloPrecio from './ArticuloPrecio/ImportarArticuloPrecio'

const App = () => {
    return (
        <Provider store={store}>
            <Router>
                <Fragment>
                    <Switch>
                        <Route exact path="/" component={Login} />

                        <Route exact path="/home" component={Home} />
                        <Route
                            exact
                            path={INFORMES_HOME_PATH}
                            component={InformesHome}
                        />
                        <Route
                            exact
                            path={INFORMES_CONCILIACION_PATH}
                            component={InformeConciliacion}
                        />
                        <Route
                            exact
                            path={CONFIGURACION_PATH}
                            component={Configuracion}
                        />

                        <Route
                            exact
                            path="/backoffice/tenants"
                            component={BackofficeTenants}
                        />
                        <Route
                            exact
                            path="/backoffice/add-tenant"
                            component={AddTenant}
                        />
                        <Route
                            exact
                            path="/backoffice/tenants-eliminados"
                            component={BackofficeTenantsEliminados}
                        />

                        <Route exact path="/vender" component={ConsolaVenta} />

                        <Route exact path="/articulos" component={Articulos} />
                        <Route
                            exact
                            path="/add-articulo"
                            component={AddArticulo}
                        />
                        <Route
                            exact
                            path="/add-articulo-compuesto"
                            component={AddArticuloCompuestos}
                        />
                        <Route
                            exact
                            path="/add-articulo-importar"
                            component={AddArticuloImportar}
                        />
                        <Route
                            exact
                            path="/edit-articulo/:id"
                            component={EditArticulo}
                        />
                        <Route
                            exact
                            path="/edit-articulo-compuesto/:id"
                            component={EditArticuloCompuesto}
                        />
                        <Route
                            exact
                            path="/articulos-eliminados"
                            component={ArticulosEliminados}
                        />

                        <Route
                            exact
                            path="/departamentos"
                            component={Departamentos}
                        />
                        <Route
                            exact
                            path="/add-departamento"
                            component={AddDepartamento}
                        />
                        <Route
                            exact
                            path="/edit-departamento/:id"
                            component={EditDepartamento}
                        />
                        <Route
                            exact
                            path="/departamentos-eliminados"
                            component={DepartamentosEliminados}
                        />
                        <Route
                            exact
                            path="/add-departamento-importar"
                            component={AddDepartamentoImportar} //
                        />

                        <Route exact path="/familias" component={Familias} />
                        <Route
                            exact
                            path="/add-familia"
                            component={AddFamilia}
                        />
                        <Route
                            exact
                            path="/edit-familia/:id"
                            component={EditFamilia}
                        />
                        <Route
                            exact
                            path="/familia-eliminada"
                            component={FamiliaEliminada}
                        />
                        <Route
                            exact
                            path="/add-familia-importar"
                            component={AddFamiliaImportar}
                        />

                        <Route exact path="/marcas" component={Marcas} />
                        <Route exact path="/add-marca" component={AddMarca} />
                        <Route
                            exact
                            path="/edit-marca/:id"
                            component={EditMarca}
                        />
                        <Route
                            exact
                            path="/marcas-eliminadas"
                            component={MarcasEliminadas}
                        />
                        <Route
                            exact
                            path="/add-marca-importar"
                            component={AddMarcaImportar} //
                        />

                        <Route
                            exact
                            path="/comprobantes"
                            component={TipoComprobantes}
                        />
                        <Route
                            exact
                            path="/add-comprobante"
                            component={AddTipoComprobante}
                        />
                        <Route
                            exact
                            path="/edit-comprobante/:id"
                            component={EditarTipoComprobante}
                        />
                        <Route
                            exact
                            path="/compras-eliminadas"
                            component={ComprasEliminadas}
                        />

                        <Route exact path="/tarjetas" component={Tarjetas} />
                        <Route
                            exact
                            path="/add-tarjeta"
                            component={AddTarjeta}
                        />
                        <Route
                            exact
                            path="/edit-tarjeta/:id"
                            component={EditTarjeta}
                        />
                        <Route
                            exact
                            path="/tarjetas-eliminadas"
                            component={TarjetasEliminadas}
                        />

                        <Route
                            exact
                            path="/listas-precios"
                            component={ListasPrecios}
                        />
                        <Route
                            exact
                            path="/add-lista-precio"
                            component={AddListaPrecio}
                        />
                        <Route
                            exact
                            path="/edit-lista-precio/:id"
                            component={EditListaPrecio}
                        />
                        <Route
                            exact
                            path="/lista-precio-eliminada"
                            component={ListasPreciosEliminados}
                        />
                        <Route
                            exact
                            path="/add-lista-precio-importar"
                            component={ImportarListaPrecio}
                        />

                        <Route exact path="/ofertas" component={Ofertas} />
                        <Route exact path="/add-oferta" component={AddOferta} />
                        <Route
                            exact
                            path="/edit-oferta/:id"
                            component={EditOferta}
                        />
                        <Route
                            exact
                            path="/ofertas-eliminadas"
                            component={OfertasEliminadas}
                        />

                        <Route exact path="/clientes" component={Clientes} />
                        <Route
                            exact
                            path="/add-cliente"
                            component={AddCliente}
                        />
                        <Route
                            exact
                            path="/edit-cliente/:id"
                            component={EditCliente}
                        />
                        <Route
                            exact
                            path="/clientes-eliminados"
                            component={ClientesEliminados}
                        />

                        <Route exact path="/cargos" component={Cargos} />
                        <Route exact path="/add-cargo" component={AddCargo} />
                        <Route
                            exact
                            path="/edit-cargo/:id"
                            component={EditCargo}
                        />

                        <Route
                            exact
                            path="/sucursales"
                            component={Sucursales}
                        />
                        <Route
                            exact
                            path="/add-sucursal"
                            component={AddSucursal}
                        />
                        <Route
                            exact
                            path="/edit-sucursal/:id"
                            component={EditSucursal}
                        />
                        <Route
                            exact
                            path="/sucursales-eliminadas"
                            component={SucursalesEliminados}
                        />

                        <Route exact path="/empleados" component={Empleados} />
                        <Route
                            exact
                            path="/add-empleado"
                            component={AddEmpleado}
                        />
                        <Route
                            exact
                            path="/edit-empleado/:id"
                            component={EditEmpleado}
                        />
                        <Route
                            exact
                            path="/empleados-eliminados"
                            component={EmpleadosEliminados}
                        />

                        <Route
                            exact
                            path="/cuentas-corrientes-clientes"
                            component={CuentasCorrientes}
                        />
                        <Route
                            exact
                            path="/add-cuenta-corriente-clientes"
                            component={AddCuentaCorriente}
                        />
                        <Route
                            exact
                            path="/edit-cuenta-corriente-clientes/:id"
                            component={EditCuentaCorriente}
                        />
                        <Route
                            exact
                            path="/cuentas-corrientes-cliente-eliminada"
                            component={CuentasCorrientesClienteEliminada}
                        />
                        <Route
                            exact
                            path="/cuentas-corrientes-informes-venta-adeudada"
                            component={CuentasCorrientesInformeVentaAdeudada}
                        />
                        <Route
                            exact
                            path="/ingreso-pago-cliente"
                            component={IngresoPagoCliente}
                        />

                        <Route
                            exact
                            path="/cuentas-corrientes-proveedores"
                            component={CuentasCorrientesProveedor}
                        />
                        <Route
                            exact
                            path="/add-cuenta-corriente-proveedores"
                            component={AddCuentaCorrienteProveedor}
                        />
                        <Route
                            exact
                            path="/edit-cuenta-corriente-proveedores/:id"
                            component={EditCuentaCorrienteProveedor}
                        />
                        <Route
                            exact
                            path="/cuentas-corrientes-proveedores-eliminada"
                            component={CuentasCorrientesProveedorEliminada}
                        />
                        <Route
                            exact
                            path="/ingreso-pago-proveedor"
                            component={IngresoPago}
                        />

                        {/* <Route exact path='/pedidos' component={PedidosSucursal} />
            <Route exact path='/add-pedido-sucursal' component={AddPedidoSucursal} /> */}

                        <Route
                            exact
                            path="/stock-sucursal"
                            component={StockSucursal}
                        />
                        <Route
                            exact
                            path="/stock-informes"
                            component={InformeStockBalance}
                        />
                        <Route
                            exact
                            path="/edit-stock-sucursal/:id"
                            component={EditStockSucursal}
                        />
                        <Route
                            exact
                            path="/add-stock-sucursal"
                            component={AddStockSucursal}
                        />
                        <Route
                            exact
                            path="/delete-stock-sucursal"
                            component={StockSucursalEliminado}
                        />
                        <Route
                            exact
                            path="/add-stock-sucursal-importar"
                            component={AddStockImportar}
                        />
                        <Route
                            exact
                            path="/generar-etiquetas"
                            component={GenerarEtiquetas}
                        />

                        <Route exact path="/usuarios" component={Usuario} />
                        <Route
                            exact
                            path="/add-usuario"
                            component={AddUsuario}
                        />
                        <Route
                            exact
                            path="/edit-usuario/:id"
                            component={EditUsuario}
                        />
                        <Route
                            exact
                            path="/usuarios-eliminados"
                            component={UsuariosEliminados}
                        />

                        <Route
                            exact
                            path="/proveedores"
                            component={Proveedores}
                        />
                        <Route
                            exact
                            path="/add-proveedor"
                            component={AddProveedor}
                        />
                        <Route
                            exact
                            path="/edit-proveedor/:id"
                            component={EditProveedor}
                        />
                        <Route
                            exact
                            path="/proveedores-eliminados"
                            component={ProveedoresEliminados}
                        />

                        <Route exact path="/compras" component={Compras} />
                        <Route
                            exact
                            path="/add-compras"
                            component={AddCompra}
                        />
                        <Route
                            exact
                            path="/compras-informes"
                            component={InformeCompras}
                        />

                        <Route exact path="/cajas" component={Cajas} />
                        <Route
                            exact
                            path="/cajas-eliminadas"
                            component={CajasEliminadas}
                        />
                        <Route
                            exact
                            path="/apertura-caja"
                            component={OpenCaja}
                        />
                        <Route exact path="/edit-caja" component={EditCaja} />
                        <Route
                            exact
                            path="/cajas-informes"
                            component={InformeCajas}
                        />

                        <Route exact path="/pdf" component={Pdf} />
                        <Route
                            exact
                            path="/ticket-venta"
                            component={TicketVenta}
                        />

                        <Route
                            exact
                            path="/correo-electronico"
                            component={CorreoElectronico}
                        />

                        <Route
                            exact
                            path="/presupuestos"
                            component={Presupuestos}
                        />
                        <Route
                            exact
                            path="/presupuestos-eliminados"
                            component={PresupuestosEliminado}
                        />

                        <Route exact path="/informes" component={Informes} />
                        <Route exact path="/ventas" component={Ventas} />
                        <Route
                            exact
                            path="/ventas-eliminadas"
                            component={VentaEliminada}
                        />

                        <Route
                            exact
                            path="/punto-ventas"
                            component={PuntoVenta}
                        />
                        <Route
                            exact
                            path="/add-punto-venta"
                            component={AddPuntoVenta}
                        />
                        <Route
                            exact
                            path="/edit-punto-venta/:id"
                            component={EditPuntoVenta}
                        />
                        <Route
                            exact
                            path="/punto-ventas-eliminadas"
                            component={PuntoVentaEliminadas}
                        />

                        <Route
                            exact
                            path="/dato-fiscal"
                            component={DatoFiscal}
                        />
                        <Route
                            exact
                            path="/add-dato-fiscal"
                            component={AddDatoFiscal}
                        />
                        <Route
                            exact
                            path="/edit-dato-fiscal/:id"
                            component={EditDatoFiscal}
                        />
                        <Route
                            exact
                            path="/dato-fiscal-eliminados"
                            component={DatoFiscalEliminado}
                        />

                        <Route
                            exact
                            path="/articulo-precios"
                            component={ArticuloPrecio}
                        />
                        <Route
                            exact
                            path="/add-articulo-precio-importar"
                            component={ImportarArticuloPrecio}
                        />
                        <Route
                            exact
                            path="/add-articulo-precio"
                            component={AddArticuloPrecio}
                        />
                        <Route
                            exact
                            path="/edit-articulo-precio/:articuloId/:listaPrecioId"
                            component={EditArticuloPrecio}
                        />

                    </Switch>
                </Fragment>
            </Router>
        </Provider>
    )
}

export default App
